export const actionTypes = {
  ASSET_AUDITORS_CLEAR: "ASSET_AUDITORS_CLEAR",
  ASSET_AUDITORS_SET: "ASSET_AUDITORS_SET",
  ASSET_AUDITORS_MERGE: "ASSET_AUDITORS_MERGE"
};

export const actionCreators = {
  clear: () => ({
    type: actionTypes.ASSET_AUDITORS_CLEAR
  }),
  set: (assetAuditors: Array<any>) => ({
    type: actionTypes.ASSET_AUDITORS_SET,
    payload: { assetAuditors }
  }),
  merge: (assetAuditors: Array<any>) => ({
    type: actionTypes.ASSET_AUDITORS_MERGE,
    payload: { assetAuditors }
  })
};

export default {
  create: actionCreators,
  type: actionTypes
};
